import Vue from "vue";

// export function getTranslationData(elementData) {
//     // var adminLanguage = store.state.admin.adminLanguage;
//     // const { translationDtos } = elementData
//     // if (translationDtos != null && translationDtos.length > 0) {
//     //     var translationchk = translationDtos.filter((elem) => elem.languageBasicInfoCode == adminLanguage);
//     //     if (translationchk != null && translationchk.length > 0) {
//     //         return translationchk[0].basicInfoTitle;
//     //     }
//     // }
//     // return elementData.basicInfoTitle;
// }

// Vue.prototype.$getTranslationData = getTranslationData

import moment from "moment/moment";

Vue.filter("moment", function (value, formatString)
{
  formatString = formatString || "YYYY-MM-DD";
  return moment(value).format(formatString);
});
